export default "__VITE_ASSET__8CdB_XtK__"